import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeCH from '@angular/common/locales/de-CH';
import localeFR from '@angular/common/locales/fr-CH';
import localeIT from '@angular/common/locales/it-CH';
import { Pipe, PipeTransform } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import Debug from 'debug';

registerLocaleData(localeCH);
registerLocaleData(localeDE);
registerLocaleData(localeFR);
registerLocaleData(localeIT);
const debug = Debug('aumico:aumico-lib-core-fe:DateTimeLocalePipe');

@Pipe({
    name: 'dateTimeLocale',
})
export class DateTimeLocalePipe implements PipeTransform {
    constructor(private i18NextService: I18NextService) {}

    transform(
        value: string | Date,
        incrementBy?: number,
        language?: string,
        includeTime: boolean = true,
        includeSeconds: boolean = true,
    ) {
        try {
            // Base date options
            const dateOptions: Intl.DateTimeFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            };

            // Add time options if includeTime is true
            if (includeTime) {
                dateOptions.hour = '2-digit';
                dateOptions.minute = '2-digit';
                if (includeSeconds) {
                    dateOptions.second = '2-digit';
                }
            }

            const date = new Date(value);
            if (incrementBy != null) {
                date.setDate(date.getDate() + incrementBy);
            }

            const formatLanguage = language == null ? this.i18NextService.language : language;

            const dateTimeFormat = new Intl.DateTimeFormat(formatLanguage, dateOptions);
            const dateTimeLocale = dateTimeFormat.format(date);
            return dateTimeLocale;
        } catch (error) {
            debug('try to convert a value, which is no date...', value);
            return value;
        }
    }
}
